import React from 'react';
import ReactDOM from 'react-dom';
import AppWrapper from './AppWrapper';
import {BrowserRouter} from 'react-router-dom';
import { Provider  } from "react-redux";
import store from './store';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'prismjs/themes/prism-coy.css';

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<AppWrapper></AppWrapper>
		</BrowserRouter>
	</Provider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
